import { Component, inject } from '@angular/core';
import { FlowpilotChatPopUpLayoutComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/pop-up/flowpilot-chat-pop-up-layout.component';
import { FlowpilotChatsActionsComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/chats/flowpilot-chats-actions.component';
import { FlowpilotChatsListComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/chats/flowpilot-chats-list.component';
import { FlowpilotPopUpService } from '@core/components/sidebar/components/flowpilot/window/content/services/flowpilot-pop-up.service';

@Component({
  selector: 'app-flowpilot-chat-pop-up',
  imports: [
    FlowpilotChatPopUpLayoutComponent,
    FlowpilotChatsActionsComponent,
    FlowpilotChatsListComponent,
  ],
  styles: [
    `
      :host {
        display: block;
        width: 275px;
        height: 100%;
      }
    `,
  ],
  template: `
    <app-flowpilot-chat-pop-up-layout>
      <app-flowpilot-chats-actions actions />

      <app-flowpilot-chats-lists
        chats
        (menuOpened)="onOpenMenu()"
        (menuClosed)="onCloseMenu()" />
    </app-flowpilot-chat-pop-up-layout>
  `,
})
export class FlowpilotChatPopUpComponent {
  /** INJECTIONS **/
  /****/
  private readonly popUpService = inject(FlowpilotPopUpService);

  protected onOpenMenu() {
    this.popUpService.menuOpen = true;
  }

  protected onCloseMenu() {
    // use timeout, so when the menu is closed, the update is delayed just enough for the mouse enter event on the pop-up can register properly
    setTimeout(() => {
      this.popUpService.menuOpen = false;
    }, 0);
  }
}
